// @ts-nocheck
import { createRouter, createWebHashHistory } from 'vue-router'
import DashboardView from '../views/Dashboard.vue'
import StatisticsView from '../views/StatisticsView.vue'
import InfoView from "../views/InfoView.vue";
import PWAView from "../views/PWAView.vue";
import Impressum from "../views/Impressum.vue";  // import your admin view
import History from "../views/History.vue";  // import your admin view

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: '/',
      component: DashboardView
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardView
    },
    { path: '/history',
      name: 'history',
      component: History },
    {
      path: '/info',
      name: 'info',
      component: InfoView
    },
    {
      path: '/download',
      name: 'download',
      component: PWAView
    },
    {
      path: '/stats',
      name: 'stats',
      component: StatisticsView  // new route for admin
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: Impressum
    }
  ]
})

export default router
